"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const offchainPoolToken_1 = __importDefault(require("./offchainPoolToken"));
const utils_1 = require("../utils");
class OffchainLendingVault extends offchainPoolToken_1.default {
    constructor(offchain, vaultAddress) {
        super();
        this.getOffchain = () => this.offchain;
        this.getVaultAddress = () => this.vaultAddress;
        this.offchain = offchain;
        this.vaultAddress = vaultAddress;
    }
    getPoolTokenData() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.offchain.getLendingVaultData(this.vaultAddress);
        });
    }
    getTotalSupply() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getPoolTokenParamFloat("totalSupply");
        });
    }
    getLastUpdate() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getPoolTokenParamInt("lastUpdate");
        });
    }
    getAccrueFactor() {
        return __awaiter(this, void 0, void 0, function* () {
            const now = Date.now() / 1000;
            const timeElapsed = now - (yield this.getLastUpdate());
            const supplyRate = yield this.getSupplyRate();
            return 1 + timeElapsed * supplyRate;
        });
    }
    getCurrentExchangeRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const lastExchangeRate = yield this.getExchangeRate();
            const accrueFactor = yield this.getAccrueFactor();
            return lastExchangeRate * accrueFactor;
        });
    }
    // Vault Supply
    getVaultSupply() {
        return __awaiter(this, void 0, void 0, function* () {
            const totalSupply = yield this.getTotalSupply();
            const exchageRate = yield this.getCurrentExchangeRate();
            return totalSupply * exchageRate;
        });
    }
    getVaultSupplyUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultSupply = yield this.getVaultSupply();
            const tokenPrice = yield this.getTokenPriceFast();
            return vaultSupply * tokenPrice;
        });
    }
    // Reserve Factor
    getReserveFactor() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getPoolTokenParamFloat("reserveFactor");
        });
    }
    // Supply Rate
    getSupplyRate() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getPoolTokenParamFloat("supplyRate");
        });
    }
    getSupplyAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            const supplyRate = yield this.getSupplyRate();
            return (0, utils_1.toAPR)(supplyRate);
        });
    }
    // Available Liquidity
    getAvailableLiquidity() {
        return __awaiter(this, void 0, void 0, function* () {
            return Math.min(yield this.getPoolTokenParamFloat("availableLiquidity"), yield this.getVaultSupply());
        });
    }
    getAvailableLiquidityUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const availableLiquidity = yield this.getAvailableLiquidity();
            const tokenPrice = yield this.getTokenPriceFast();
            return availableLiquidity * tokenPrice;
        });
    }
    // Token price getters
    getTokenPriceFast(fallback = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getTokenPriceAccurate();
        });
    }
    getTokenPriceAccurate() {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenAddress = yield this.getUnderlyingAddress();
            return this.getOffchain().getPriceHelper().getDebankTokenPrice(tokenAddress);
        });
    }
}
exports.default = OffchainLendingVault;
